(function () {
  function updateStockPill(root, variant) {
    var pill = root.querySelector('[data-dropplier-stock-pill]');
    if (!pill || !variant) return;
    var label = pill.querySelector('[data-dropplier-stock-label]');
    var available = !!variant.available;
    var quantity = Number(variant.inventory_quantity || 0);
    pill.classList.toggle('dropplier-pdp-stock-pill--soldout', !available);
    if (!label) return;
    if (!available) {
      label.textContent = 'Currently out of stock';
    } else if (quantity > 0 && quantity < 5000) {
      label.textContent = quantity + ' units available';
    } else {
      label.textContent = 'Available now';
    }
  }

  function initPdp(root) {
    if (!root || root.dataset.dropplierPolished === 'true') return;
    root.dataset.dropplierPolished = 'true';
    var sectionId = root.dataset.section;
    var variantDataScript = sectionId && document.getElementById('variant-data-' + sectionId);
    if (variantDataScript) {
      try {
        var variantData = JSON.parse(variantDataScript.textContent);
        if (variantData && variantData.currentVariant) updateStockPill(root, variantData.currentVariant);
      } catch (e) {}
    }
    document.addEventListener('variant:change', function (event) {
      if (event && event.detail && event.detail.variant) updateStockPill(root, event.detail.variant);
    });
  }

  function boot() {
    document.querySelectorAll('product-info.custom_product_page').forEach(initPdp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
